import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material';
import { borderRadius } from '../../../theme/theme';
import type { ExportLogEntry } from '../lib/exportRunLog';

interface ExportFailuresAlertProps {
  readonly entries: readonly ExportLogEntry[];
  readonly partialSuccess: boolean;
  readonly onClose: () => void;
  readonly onOpenLog: () => void;
}

export default function ExportFailuresAlert({
  entries,
  partialSuccess,
  onClose,
  onOpenLog,
}: ExportFailuresAlertProps) {
  if (entries.length === 0) {
    return null;
  }

  return (
    <Alert
      severity={partialSuccess ? 'warning' : 'error'}
      onClose={onClose}
      data-testid="export-pcf-failures"
      sx={{ mx: 1, mt: 1, borderRadius: `${borderRadius.md}px` }}
    >
      <AlertTitle sx={{ fontWeight: 700 }}>
        {entries.length} PCF export failure{entries.length === 1 ? '' : 's'}
      </AlertTitle>
      <Typography variant="body2">
        {partialSuccess
          ? 'Other PCF files were exported successfully. Review the failures below.'
          : 'The PCF export did not complete for the items below.'}
      </Typography>
      <Box component="ul" sx={{ my: 0.75, pl: 2.5 }}>
        {entries.map((entry) => (
          <Box component="li" key={entry.id} sx={{ mb: entry.suggestedAction ? 0.75 : 0 }}>
            <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>
              <strong>{entry.subject}</strong>: {entry.message}
            </Typography>
            {entry.suggestedAction ? (
              <Typography variant="body2" sx={{ color: 'text.secondary', overflowWrap: 'anywhere' }}>
                <strong>What to do:</strong> {entry.suggestedAction}
              </Typography>
            ) : null}
          </Box>
        ))}
      </Box>
      <Button size="small" variant="outlined" color="inherit" onClick={onOpenLog}>
        Open export log
      </Button>
    </Alert>
  );
}
